<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">{{title}}</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height:180px;">
           <div>
             <p>{{present}}</p>
               <!-- <h5>HOTEL COZZI和逸飯店・台南西門館平日四人客房住宿券（不含早餐，價值$4,500元）</h5>
                <p>※票券上銀行信託期限並非使用期限，本票券優惠期限逾期後不得要求提供原優惠，但仍可依其面額折抵$2900元。</p>

                <p>※ 本賣場票券為專案採購，載明之面額為【$2900元】，不等同於本賣場零售價，無法接受者請勿購買。</p>

                <p>※ 如有退貨問題須於鑑賞期內聯絡原購買單位，逾鑑賞期恕不受理。</p>

                <p>使用1張，淡日加價NT$1,400元可享精緻雙人客房住宿乙晚(不含早餐)。</p>
                <p>使用2張，淡日入住可享豪華雙人客房住宿乙晚，含自助式早餐兩客。</p>

                <p>淡日定義:週日、週一及國定假日 旺日需另加價NT$800。</p> -->
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'

export default {
  name: 'HealthCeremonyModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    present:{
      type:String,
      default:''
    }
  },
  data() {
      return {}
  },
  methods: {
      submit() {
          this.$emit('close');
      }
      
  },
  computed: {
  }
}
</script>
